export default __webpack_public_path__ + "static/media/VAGINAL-DISCHARGE.2c46bd55.png";